/**
 * ToastController - Toast notification display
 */

const TOAST_DURATION = 2500; // ms

/**
 * Show a toast message
 * @param {string} message - Message to display
 * @param {boolean} isError - Whether this is an error toast
 */
export function showToast(message, isError = false) {
    const toast = document.getElementById('toast');
    if (!toast) {
        console.warn('Toast element not found');
        return;
    }
    
    toast.textContent = message;
    toast.className = 'toast' + (isError ? ' error' : '');
    toast.classList.add('show');
    
    setTimeout(() => toast.classList.remove('show'), TOAST_DURATION);
}
